import style from './menu-socials.scss';
import inView from 'in-view';
import staticSizes from './../../../design-system/layout/static-sizes';

const script = () => {
  const cssClass: string = 'MenuSocials';
  const cssClassList: string = `${cssClass}-list`;
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    inView.offset(staticSizes.params['in-view'].offset.mobile);
    inView(`.${cssClassList}, .${cssClass} .menu`)
      .once('enter', ()=>{
        elt.classList.add('isInViewport');
      });
  }
};

export {
  style,
  script,
};
